<template>
    <v-layout row wrap>
        <v-flex xs12 >
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Energy Consumption Trend
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12>
                                <date-range-selector class="ml-4" v-model="dateRange"></date-range-selector>
                    </v-flex>
                    <v-flex xs12 v-show="loading">
                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                    </v-flex>
                    <v-flex xs12 v-if="data2" v-show="!loading">
                        <vue-plotly disable-responsive show-export :data="data2" :layout="layout2" :options="options2"/>

                        <vue-plotly disable-responsive show-export  v-for="equipData in data2" v-if="equipData.hasOwnGraph" :data="[equipData]" :layout="{'title':equipData.name,'yaxis':{'title':'Energy consumption (kWh)'},'xaxis':{'title':'Time (daily)'}}" :options="{}"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import DateRangeSelector from '../components/DateRangeSelector'
    import {callAPI,getResult} from '@/helper'
    import VuePlotly from '@/components/VuePlotly'
    import moment from 'moment'



    export default {
        name: 'EnergyTrend',
        components: {DateRangeSelector,VuePlotly},
        computed: {

        },
        data () {
            return {
                dateRange: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
                loading:true,
                data2:null,
                timeout:null,
                options2: {},
                layout2:{
                    title: "Energy Consumption",
                    yaxis: {
                        title: 'Energy consumption (kWh)'
                    },
                    xaxis: {
                        title: 'Time (daily)'
                    }
                },


            }
        },
        methods:{
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.doRefresh,200);
            },
            doRefresh() {
                let me=this;
                me.loading=true;
                let promises=[];
                let powerVar="Comp_Power";
                if(this.$store.state.pointsListStore.pointsList.facility_name=="ES3"){

                    powerVar="Elect-Load"
                }
                let timestamp=null;
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(equip.equipment_type==='chiller'){
                        promises.push(callAPI('data/',
                            {
                                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_name': equip.equipment_name,
                                'agg': 'D',
                                'agg_op': 'sum',
                                'date_range':[me.dateRange.start, me.dateRange.end+" 23:59"],
                                'sensor_names': [powerVar]
                            }
                        ))
                    } else if(equip.equipment_type==='pump'&&this.$store.state.pointsListStore.pointsList.facility_name=="SHT"){
                        promises.push(callAPI('data/',
                            {
                                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_name': equip.equipment_name,
                                'agg': 'D',
                                'agg_op': 'sum',
                                'date_range':[me.dateRange.start, me.dateRange.end+" 23:59"],
                                'sensor_names': ['KW']
                            }
                        ))
                    }
                }



                Promise.all(promises).then(function(reses) {
                    let secondChartData = [];
                    let colorMap={
                        "ACPC-1":"rgba(255, 127, 14,0.5)",
                        "ACPC-2":"rgba(214, 39, 40,0.5)",
                        "ACPC-3":"rgba(44, 160, 44, 0.5)",
                        "ACPC-4":"rgba(31, 119, 180,0.5)",
                        "ACPC-5": "rgba(148, 103, 189,0.5)",
                        "ACPC-6": "rgba(140, 86, 75,0.5)",
                        "ACPC-7": "rgba(227, 119, 194,0.5)",
                        "ACPC-8": "rgba(127, 127, 127,0.5)",
                        "ACPC-9": "rgba(188, 189, 34,0.5)",
                        "Chiller1": "rgba(255, 127, 14,0.5)",
                        "Chiller2": "rgba(214, 39, 40,0.5)",
                        "Chiller3": "rgba(44, 160, 44, 0.5)",
                        "Chiller4": "rgba(31, 119, 180,0.5)",
                        "Chiller5": "rgba(148, 103, 189,0.5)",
                        "Chiller6": "rgba(140, 86, 75,0.5)",
                        "Chiller7": "rgba(227, 119, 194,0.5)",
                        "Chiller8": "rgba(127, 127, 127,0.5)",
                        "Chiller9": "rgba(188, 189, 34,0.5)",
                        "Chiller_1A": "rgba(255, 127, 14,0.5)",
                        "Chiller_1B": "rgba(214, 39, 40,0.5)",
                        "Chiller_2": "rgba(44, 160, 44, 0.5)",
                        "Chiller_3": "rgba(31, 119, 180,0.5)",
                        "Chiller_4": "rgba(148, 103, 189,0.5)",
                        "Chiller_5": "rgba(140, 86, 75,0.5)",
                        "Chiller_6": "rgba(227, 119, 194,0.5)",
                        "Chiller_7": "rgba(127, 127, 127,0.5)",
                    };
                    for (let res of reses) {
                        if(!timestamp){
                            timestamp=res.data.timestamp;
                        }
                        if (res.data[powerVar]) {
                            secondChartData.push({
                                x: timestamp,
                                y: res.data[powerVar].map(i=>i/me.$store.state.pointsListStore.pointsList.sampling_freq),
                                name: JSON.parse(res.config.data)["equipment_name"],
                                fillcolor:colorMap[JSON.parse(res.config.data)["equipment_name"]],
                                hasOwnGraph:true,
                                stackgroup: 'one',
                                type: 'scatter',
                                mode: 'none'
                            });
                        } else if (res.data['KW']) {
                            secondChartData.push({
                                x: timestamp,
                                y: res.data['KW'].map(i=>i/me.$store.state.pointsListStore.pointsList.sampling_freq),
                                name: JSON.parse(res.config.data)["equipment_name"],
                                stackgroup: 'one',
                                type: 'scatter',
                                mode: 'none'
                            });
                        }
                    }
                    secondChartData.sort((a, b) => (a.name > b.name) ? 1 : -1)
                    me.data2=secondChartData;
                    me.loading=false;
                });

            }
        },
        mounted() {
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(maxDate){
                this.dateRange={
                    start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),
                    end: moment(maxDate).format('YYYY-MM-DD')
                }
            }
            this.refresh();
        },
        watch: {
            dateRange () {
                this.refresh()
            }
        }


    }
</script>
